<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    تابلو اعلانات
                    <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>


            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2">
                <div class="p-3 d-flex">
                    <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                        <i class="fa fa-filter text-white"></i>
                    </button>
                    <div class="filter-row-scrollable">

                    </div>
                </div>
            </div>
            <!--<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>-->

            <div class="card card-style mb-2" v-for="item in NoticeMassageUserList" :key="item.noticeMessageId">
                <div class="p-3" :id="'Invite-'+item.noticeMessageId">
                    <button data-toggle="collapse" type="button" :data-target="'#collapse-'+item.noticeMessageId" class="no-effect collapsed accordion-btn" aria-expanded="false">
                        <span class="d-flex justify-content-between align-items-center">
                            <b class="font-13 text-dark">{{item.title}}</b>
                            <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                        </span>
                    </button>
                </div>

                <div class="collapse border-t" :id="'collapse-'+item.noticeMessageId" @click.prevent="openDetails(item.noticeMessageId)">
                    <div class="d-flex justify-content-between py-2 pr-4 pl-3">
                        <span><i class="fa fa-calendar text-warning ml-2"></i>{{item.createDateTimeFa}}</span>
                        <span><i class="fa fa-bullhorn color-magenta2-dark ml-2"></i>{{item.viewDateTimeFa}}</span>
                    </div>
                    <div class="d-flex justify-content-between py-2 pr-4 pl-3">
                        <div class="d-flex justify-content-between" style="width:90%">
                            <span class="d-inline-flex align-items-center">
                                <!--اگر کاربر ثبت کننده تصویر پروفایل نداشت-->
                                <!--<i class="fa fa-user color-green2-light ml-2"></i>-->
                                <!--تصویر کاربر ثبت کننده اعلان-->
                                <img v-if="item.userImg!=null && item.userImg!=''" :src="item.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                <i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>
                                <span>{{item.creatorUserTitle}}</span>
                            </span>
                            <span class="font-14 text-muted"></span>
                        </div>
                        <span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="NoticeMassageUserList.length==0 && pageLoading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">هیج موردی یافت نشد.</p>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                </div>
            </transition>
            <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
                <div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn">
                    <router-link to="/NoticeMassageUser">
                        <div class="icon icon-m rounded-m color-white bg-green2-light">
                            <i class="fa fa-plus"></i>
                        </div>
                    </router-link>
                </div>
            </transition>
        </div>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'NoticeMassageUserEdit', params: { NoticeMessageId: noticeMassageUserId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="DeleteNoticeMassageUser" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h4 class="modal-title mt-0">جستجو</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">

                        <div class="w-100 search-box rounded-m position-relative mb-3">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                        </div>
                        <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

                        <button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="GetNoticeMassageUserList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import calendarFilter from '../Components/CalendarFilter.vue';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "calendar-filter": calendarFilter,
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                mod: false,
                pageLoading: true,
                pageLoaded: false,
                itemID: 0,
                date: null,
                noticeMassageUserId: 0,
                list: []
            };
        },
        computed: {
            NoticeMassageUserList() {
                return this.list;
            },
        },
        methods: {
            showMenu(t) {
                this.noticeMassageUserId = t.noticeMessageId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            selectDate(d) {
                this.date = d;
            },
            openDetails(id) {
                this.$router.push({ name: 'NoticeMassageUserEdit', params: { NoticeMessageId: id } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            DeleteNoticeMassageUser() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.pageLoading = true;
                    this.$http
                        .get("NoticeMassageUser/Delete?id=" + this.noticeMassageUserId)
                        .then((data) => {
                            var res = data.data;
                            this.pageLoading = false;
                            if (res.isSuccess) {
                                this.GetNoticeMassageUserList();
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                });
            },
            GetNoticeMassageUserList() {
                this.pageLoading = true;
                this.$http
                    .get("NoticeMassageUser/GetList"
                        , {
                            params: {
                                mode: this.mod,
                                text: this.searchKey,
                                date: this.date,

                            }
                        })
                    .then((data) => {
                        var res = data.data;
                        this.list = res;
                        this.pageLoading = false;
                    });

            },
        },
        created() {
            this.GetNoticeMassageUserList();
        },
        mounted() {
            document
                .querySelectorAll(".menu-box-right")
                .forEach((a) => (a.style.display = "block"));
        },
    }
</script>